// @ts-nocheck
import Winsta from "@/assets/icons/Winsta";
import peti from "@/assets/assets/peti.png";
import footerLogo from "@/assets/logo2.png";
import WFacbook from "@/assets/icons/WFacbook";
import WYt from "@/assets/icons/WYt";
import { Link } from "react-router-dom";
import { useToast } from "@/components/hooks/use-toast";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { subscribeNewsletter } from "@/api/apiFunction";
import { HashLink } from "react-router-hash-link";

const Footer = () => {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const { mutate, isPending } = useMutation({
    mutationFn: subscribeNewsletter,
    onSuccess: () => {
      toast({
        title: "Subscribed Successfully!",
        description: "You have been subscribed to our newsletter.",
        duration: 5000,
      });
      setEmail("");
    },
    onError: (error) => {
      console.log("error", (error as any)?.response?.data.message);
      toast({
        title: "Subscription Failed",
        description: `${(error as any)?.response?.data.message}`,
        duration: 5000,
      });
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutate(email);
  };
  return (
    <section className="w-full  bg-[#333333] mx-auto">
      <div className="max-w-6xl mt-20 relative mx-auto">
        <div className="bg-[#D9D9D9] md:w-[95%] w-[96%] ml-2 md:ml-6 lg:w-full -top-24 absolute rounded-xl overflow-hidden p-6 shadow-lg">
          <div className="w-full relative pl-3 pb-3">
            <h1 className="text-3xl md:text-4xl font-bold pt-2 mb-4 md:mb-6 text-[#333333]">
              Subscribe to our Newsletter
            </h1>
            <h2 className="font-semibold text-[#112211] mb-1">
              Get alerts for new events!
            </h2>

            <form
              onSubmit={handleSubmit}
              className="w-full md:w-[55%] flex flex-col md:flex-row gap-4"
            >
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 p-2 border-[#d9d9d9] focus:border-[#009fa6] focus:ring-[#009fa6] border rounded-lg "
                required
              />
              <button
                type="submit"
                className="px-8 py-4 text-sm rounded-lg bg-gradient-to-r from-[#4BD5D6] to-[#009FA6] transition duration-300 ease-in-out transform hover:scale-105 hover:bg-[#4BD5D6] text-white shadow-lg hover:shadow-xl font-semibold"
                disabled={isPending}
              >
                {isPending ? "Subscribing..." : "Subscribe"}
              </button>
            </form>

            <img
              src={peti}
              alt=""
              width={300}
              className="w-54 h-54 md:w-54 md:absolute -bottom-6 right-10"
            />
          </div>
        </div>

        <div className="pt-[20rem] max-w-6xl mx-auto pb-8 md:pt-0">
          <div className="flex flex-col md:flex-row pt-48">
            <div className="ml-4 flex flex-col max-w-sm md:mt-10 md:w-[20rem]">
              <Link to={"/"}>
                <img src={footerLogo} alt="" className="w-52 " />
              </Link>
              <div className="flex flex-row gap-4 mt-5 ml-6 md:ml-16">
                <a
                  href="https://www.facebook.com/champendurance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:scale-110 transition-transform duration-300"
                >
                  <WFacbook />
                </a>
                <a
                  href="https://www.instagram.com/champendurance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:scale-110 transition-transform duration-300"
                >
                  <Winsta />
                </a>
                <a
                  href="https://www.youtube.com/channel/UClKjHJ7P8vy12gVWRU5ilug"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:scale-110 transition-transform duration-300"
                >
                  <WYt />
                </a>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mt-10 text-white justify-between ml-6 md:ml-0 md:w-[50rem]">
              <div className="w-full">
                <h1 className="font-semibold">Home</h1>
                <ul className="text-[#FFFFFF] opacity-80 mt-2 space-y-2">
                  <li>
                    <HashLink
                      smooth
                      to="/#about-us"
                      className="hover:text-[#4BD5D6] transition duration-300"
                    >
                      About Us
                    </HashLink>
                  </li>
                  <li>
                    <HashLink
                      smooth
                      to="/#our-vision"
                      className="hover:text-[#4BD5D6] transition duration-300"
                    >
                      Our Vision
                    </HashLink>
                  </li>
                  <li>
                    <HashLink
                      smooth
                      to="/#why-champ"
                      className="hover:text-[#4BD5D6] transition duration-300"
                    >
                      Why Champ
                    </HashLink>
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <h1 className="font-semibold">Quick Links</h1>
                <ul className="text-[#FFFFFF] opacity-80 mt-2 space-y-2">
                  <li>
                    <HashLink
                      smooth
                      to="/all-events"
                      className="hover:text-[#4BD5D6] transition duration-300"
                    >
                      All Events
                    </HashLink>
                  </li>
                  <li>
                    <HashLink
                      smooth
                      to="/policy"
                      className="hover:text-[#4BD5D6] transition duration-300"
                    >
                      Privacy Policy
                    </HashLink>
                  </li>
                  <li>
                    <HashLink
                      smooth
                      to="/terms"
                      className="hover:text-[#4BD5D6] transition duration-300"
                    >
                      Terms of Service
                    </HashLink>
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <h1 className="font-semibold">Contact Us</h1>
                <ul className="text-[#FFFFFF] opacity-80 mt-2 space-y-2 hover:text-[#4BD5D6] transition duration-300">
                  <li>
                    <HashLink smooth to={"/contact-us"}>
                      101, Saniket House, Prabhat Road, Pune - 411004 <br />
                      +91 8411004511 <br />
                    </HashLink>
                    <a href="mailto:info@champendurance.com">
                      info@champendurance.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className=" border-t border-gray-700 py-3 text-center">
          <p className="mt-1 text-[#FFFFFF] opacity-80">
            &copy; {new Date().getFullYear()} Champ Endurance. All rights
            reserved.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
